module.exports = __webpack_public_path__ + "static/media/balloons.aa6585a8.svg";